module.exports = __webpack_public_path__ + "img/icon_map_2_on_111.eb7ec605.png";